import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SOFTWARE_LICENCES_FEATURE_KEY } from './software-licences-collection.state';
import { SoftwareLicencesEffects } from './effects/software-licences.effects';
import { softwareLicencesReducer } from './reducers/software-licences.reducer';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { selectSoftwareLicences } from './selectors/software-licences.selector';

/**
 * Registers the software licences feature slice. Data is loaded on-demand per equipment via
 * {@link SoftwareLicencesEffects} and cached to file storage; the cache is read back when the
 * backend request fails so licences remain available offline.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(SOFTWARE_LICENCES_FEATURE_KEY, softwareLicencesReducer),
        EffectsModule.forFeature([SoftwareLicencesEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: SOFTWARE_LICENCES_FEATURE_KEY,
                persistSelector: selectSoftwareLicences,
            },
        },
    ],
})
export class SoftwareLicencesStoreModule {}
